export default class UnknownReportError extends Error {
  constructor(report) {
    super(`Unknown report '${report}'`)
    this.name = this.constructor.name
    this.report = report
  }
}
